import React from 'react';
import store from '../../store/Store';

import SwipeableViews from 'react-swipeable-views';
import { bindKeyboard } from 'react-swipeable-views-utils';

import PageContent from './../pageContent/PageContent'

import './contribution.scss';

type contributionState = {
	article: any;
	navigation: any;
}

type contributionProps = {
	article: any;
	navigation: any;
}

const BindKeyboardSwipeableViews = bindKeyboard(SwipeableViews);

class Contribution extends React.Component<contributionState, contributionProps> {

  constructor(props) {
  	super(props)

  	this.state = {
  		article: props.article,
  		navigation: props.navigation
  	}
  }

  componentDidMount() {
	store.subscribe(() => {
		this.setState({
			article: store.getState().article,
			navigation: store.getState().navigation
		})
	})
  }

  render() {
  	  const {
  	  	article,
  	  	navigation
  	  } = this.state

	  return (
	  	<div
	  		className="Contribution"
	  	>
		    <BindKeyboardSwipeableViews axis={ 'y' } resistance enableMouseEvents hysteresis={ 0.5 } animateTransitions animateHeight>
				<p
					className="Contribution"
				>
					<PageContent 
	    				article={ article }
	    				navigation={ navigation }
	    			/>
	    		</p>

	    		<p
					className="Contribution"
				>
					<PageContent 
	    				article={ article }
	    				navigation={ navigation }
		    		/>
		    	</p>

		    	<p
					className="Contribution"
				>
					<PageContent 
	    				article={ article }
	    				navigation={ navigation }
		    		/>
		    	</p>

		    	<p
					className="Contribution"
				>
					<PageContent 
	    				article={ article }
	    				navigation={ navigation }
		    		/>
		    	</p>
		    </BindKeyboardSwipeableViews>
		</div>
	  );
	}
}

export default Contribution